/**
 * @desc 分页
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(params: API.report.reportTaskRecord.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/reportTaskRecord/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
